import { useState } from 'react';
import Typography from '@primitives/Typography/Typography';
import Button from '@primitives/Button/Button';
import CallLimitHistory from './components/CallLimitHistory/CallLimitHistory';
import { useDispatch } from 'react-redux';
import { fetchCallLimitSampleFile, uploadCallLimitFile } from './CallLimitActions';
import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import { useNavigate } from 'react-router';
import UseUpload from '@cp/src/components/UploadComponent/useUpload';
import FileUploadContainer from '@cp/src/components/UploadComponent/FileUploadContainer';

const containerStyles = {
  subContainer:
    'flex flex-col items-center justify-evenly min-h-[128px] rounded-lg p-6 border-2 border-dashed border-[var(--blue-base)] bg-[var(--blue-light-bg)] m-0 box-border'
};

const CallLimit = () => {
  const { file, setFile, error, setError } = UseUpload({});
  const [showLoadingComponent, setShowLoadingComponent] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleButtonClick = async () => {
    if (!file) return;

    setShowLoadingComponent(true);
    await uploadCallLimitFile(file);
    setShowLoadingComponent(false);
    setFile(null);
    setError({ message: '', fileName: null });
  };

  const handleDownloadClick = () => {
    dispatch(fetchCallLimitSampleFile());
  };

  return (
    <div>
      <div className="h-16 w-full box-border bg-[var(--bg-primary-warm)] flex p-5">
        <div className="cursor-pointer" onClick={() => navigate(-1)}>
          <BackIcon size={'16'} />
        </div>
      </div>
      <div className="flex flex-col w-full gap-[22px] justify-center items-center mb-[50px] mt-14">
        <div className="w-[499px] h-auto shrink-0 rounded-lg border border-[var(--white-smoke)] bg-white m-auto px-3 pt-1 pb-4 shadow-base">
          <div className="flex justify-between p-3">
            <Typography variant={'h3'}>Update call limit</Typography>
            <CallLimitHistory />
          </div>

          <div className="mx-3 py-3">
            <Typography variant={'p4'} className="mb-2">
              Select a file
            </Typography>
            <FileUploadContainer
              error={error}
              file={file}
              setFile={setFile}
              setError={setError}
              showLoadingComponent={showLoadingComponent}
              setShowLoadingComponent={setShowLoadingComponent}
              handleDownloadClick={handleDownloadClick}
              styles={containerStyles}
            />
          </div>

          <div className="flex justify-end pr-3 pt-4">
            <Button
              disabled={!file || !!error?.message || showLoadingComponent}
              onClick={handleButtonClick}
            >
              {showLoadingComponent ? 'Uploading...' : 'Update'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallLimit;
